import React from 'react';
import { Row, Col, Typography, Image, Divider, Button } from 'antd';
import { Link } from 'react-router-dom';
import AppHeader from '../Layout/Header';
import FooterComponent from '../Layout/Footer';
import SdsslImage from '../Assets/ResearchLabs/SDSSL/SDSSL-Circular.jpg';
import SarlImage from '../Assets/ResearchLabs/SARL/SARL-Circular.jpg';
import GserlImage from '../Assets/ResearchLabs/GSERL/GSERL-Circular.jpg';
import SstrlImage from '../Assets/ResearchLabs/SSTRL/SSTRL-Circular.jpg';
import ArslImage from '../Assets/ResearchLabs/ARSL/ARSL-Circular.jpg';
import GsaglImage from '../Assets/ResearchLabs/GSAGL/GSAGL-Circular.jpg';
import RsgcrlImage from '../Assets/ResearchLabs/RSGCRL/RSGCRL-Circular.jpg';
import '../Styles/ResearchLabs.css';
import FooterQuote from '../Layout/FooterQuote';

const { Title, Paragraph } = Typography;

const ResearchLabsScreen = () => (
  <>
    <AppHeader />
    <main>
      <section className="research-labs-page-hero" aria-label="Research Labs" />
      <section className="lab-overview-section lab-overview-section-muted">
        <div className="lab-overview-inner">
          <Row gutter={[64, 40]} justify="space-between" align="middle">
            <Col xs={24} md={15}>
              <Title level={2} className="lab-overview-title">
                Spatial Decision Support System Lab (SDSSL)
              </Title>
              <Divider className="ncgsa-divider" />
              <Paragraph className="lab-overview-description">
                Substantial rise in public demands for provision of efficient services and systems by the government can only be met with efficient decision support systems. One way to handle this restless onslaught of demographic pressure is to improve performance of several systems and services available for public by making use of spatial data. The availability of data along with an effective decision support system can help in the understanding of problems and the possible outcomes of decisions. In addition, the availability of spatial data based decision support systems can greatly improve policy and plan making process while reducing time and human resources. Geographic Information systems (GIS) are known technology to manage spatial databases. Our research group envisions contributing in the area of Spatial Decision Support Systems (SDSS) that deals with spatial dimension through digitized geo-referenced spatial databases.
              </Paragraph>
              <Link to="/sdssl" className="lab-overview-link">
                <Button type="primary" className="lab-overview-button">Learn More</Button>
              </Link>
            </Col>
            <Col xs={24} md={9}>
              <div className="lab-overview-image-wrap">
                <Image src={SdsslImage} alt="Spatial Decision Support System Lab" className="lab-overview-image" preview={false} />
              </div>
            </Col>
          </Row>
        </div>
      </section>
      <section className="lab-overview-section">
        <div className="lab-overview-inner">
          <Row gutter={[64, 40]} justify="space-between" align="middle" className="lab-overview-row-reverse">
            <Col xs={24} md={15}>
              <Title level={2} className="lab-overview-title">
                Space and Astrophysics Research Lab (SARL)
              </Title>
              <Divider className="ncgsa-divider" />
              <Paragraph className="lab-overview-description">
                Since the beginning of the 20th century, the study of space and various astrophysical phenomena has entered a golden age. With the advent of the 21st century this research promises further exciting discoveries in these domains. This research encompasses areas as diverse as the study of the space around the Earth, the Sun and its impact on the Earth, the Solar System, the study of star systems, neutron stars, black holes as well as the study of galaxies and the large scale study about the Universe. SARL focuses on acquiring indigenous research infrastructure and develop manpower to study the dynamics of space and astrophysical systems including the ionosphere, magnetosphere, Sun, stars, galaxies, high energy astrophysical systems and gravitational waves.
              </Paragraph>
              <Link to="/sarl" className="lab-overview-link">
                <Button type="primary" className="lab-overview-button">Learn More</Button>
              </Link>
            </Col>
            <Col xs={24} md={9}>
              <div className="lab-overview-image-wrap">
                <Image src={SarlImage} alt="Space and Astrophysics Research Lab" className="lab-overview-image" preview={false} />
              </div>
            </Col>
          </Row>
        </div>
      </section>
      <section className="lab-overview-section lab-overview-section-muted">
        <div className="lab-overview-inner">
          <Row gutter={[64, 40]} justify="space-between" align="middle">
            <Col xs={24} md={15}>
              <Title level={2} className="lab-overview-title">
                GNSS and Space Education Research Lab (GSERL)
              </Title>
              <Divider className="ncgsa-divider" />
              <Paragraph className="lab-overview-description">
                Global Navigation Satellite System has emerged to be an integral part in major businesses around the world including banking, agriculture, security etc. With almost all developed nations currently operating or planning to operate a fully functional GNSS, GSERL aims to contribute in the field at regional and global level.
              </Paragraph>
              <Paragraph className="lab-overview-description lab-overview-description-followup">
                Almost all developing countries struggle with the awareness of the benefit of space science and technology among its general masses. This in turn results in loss of public support, lack of human resource and consequently a slow paced space program. Space Education Research Lab focuses on spreading mass awareness among the general masses by actively engaging them at all level in outreach and awareness activities and initiatives.
              </Paragraph>
              <Link to="/gserl" className="lab-overview-link">
                <Button type="primary" className="lab-overview-button">Learn More</Button>
              </Link>
            </Col>
            <Col xs={24} md={9}>
              <div className="lab-overview-image-wrap">
                <Image src={GserlImage} alt="GNSS and Space Education Research Lab" className="lab-overview-image" preview={false} />
              </div>
            </Col>
          </Row>
        </div>
      </section>
      <section className="lab-overview-section">
        <div className="lab-overview-inner">
          <Row gutter={[64, 40]} justify="space-between" align="middle" className="lab-overview-row-reverse">
            <Col xs={24} md={15}>
              <Title level={2} className="lab-overview-title">
                Small Satellite Technology and Research Lab (SSTRL)
              </Title>
              <Divider className="ncgsa-divider" />
              <Paragraph className="lab-overview-description">
                With the worldwide success of satellite programs and countless spins offs in terms of business, applications and research potential, space science and technology research community has now begun excessive experimentation and identification of benefits of small satellite technology. Growing concerns of space debris, enormous developmental costs and similar concerns with satellite technology have shown considerable mitigation potential through small satellites. SSTRL focuses on the cutting edge innovation and technology in the domain of micro, nano and pico satellites.
              </Paragraph>
              <Link to="/sstrl" className="lab-overview-link">
                <Button type="primary" className="lab-overview-button">Learn More</Button>
              </Link>
            </Col>
            <Col xs={24} md={9}>
              <div className="lab-overview-image-wrap">
                <Image src={SstrlImage} alt="Small Satellite Technology and Research Lab" className="lab-overview-image" preview={false} />
              </div>
            </Col>
          </Row>
        </div>
      </section>
      <section className="lab-overview-section lab-overview-section-muted">
        <div className="lab-overview-inner">
          <Row gutter={[64, 40]} justify="space-between" align="middle">
            <Col xs={24} md={15}>
              <Title level={2} className="lab-overview-title">
                Agricultural Remote Sensing Lab (ARSL)
              </Title>
              <Divider className="ncgsa-divider" />
              <Paragraph className="lab-overview-description">
                Since the beginning of the agricultural revolution some 12000 years ago, agriculture has been one of the primary means of human sustainability on planet Earth. With the population concerns around the world grows, so does the need for efficient and highly productive agricultural sector. Remote sensing has found a significant application in the agricultural sector. Through implementation of comprehensive analysis from satellite imagery, agriculture around the world can be more targeted and yielding than it was in the past decade. ARSL focuses on remote sensing, its implementation techniques and its direct relation to the quality of yield produced in a particular region.
              </Paragraph>
              <Link to="/arsl" className="lab-overview-link">
                <Button type="primary" className="lab-overview-button">Learn More</Button>
              </Link>
            </Col>
            <Col xs={24} md={9}>
              <div className="lab-overview-image-wrap">
                <Image src={ArslImage} alt="Agricultural Remote Sensing Lab" className="lab-overview-image" preview={false} />
              </div>
            </Col>
          </Row>
        </div>
      </section>
      <section className="lab-overview-section">
        <div className="lab-overview-inner">
          <Row gutter={[64, 40]} justify="space-between" align="middle" className="lab-overview-row-reverse">
            <Col xs={24} md={15}>
              <Title level={2} className="lab-overview-title">
                GIS &amp; Space Applications in Geosciences Lab (G-SAGL)
              </Title>
              <Divider className="ncgsa-divider" />
              <Paragraph className="lab-overview-description">
                Pakistan is located in one of the most seismically and tectonically active regions around the world which can be mainly attributed to the northward movement of the Indian tectonic plate at a rate of 31 mm/year and sub ducting beneath the Eurasian continent. This collision of the Indian and Eurasian plates resulted in development of world highest mountain ranges i.e. Karakoram, Himalaya and Hindu Kush mountain ranges. The historic collision of the Indian Plate with Eurasian plate and current active tectonic in Pakistan, leads to many challenges and also opportunities. The aim of the lab is to effectively utilize the tools of GIS, remote sensing data and ground data to assist in mitigation of the adverse impacts of geohazards; and exploration and management of natural resources including minerals, water and forest.
              </Paragraph>
              <a href="https://ncgsa.org.pk/gis-space-applications-in-geosciences-g-sag-lab/" className="lab-overview-link" target="_blank" rel="noreferrer">
                <Button type="primary" className="lab-overview-button">Learn More</Button>
              </a>
            </Col>
            <Col xs={24} md={9}>
              <div className="lab-overview-image-wrap">
                <Image src={GsaglImage} alt="GIS and Space Applications in Geosciences Lab" className="lab-overview-image" preview={false} />
              </div>
            </Col>
          </Row>
        </div>
      </section>
      <section className="lab-overview-section lab-overview-section-muted">
        <div className="lab-overview-inner">
          <Row gutter={[64, 40]} justify="space-between" align="middle">
            <Col xs={24} md={15}>
              <Title level={2} className="lab-overview-title">
                Remote Sensing and GIS Climatic Research Lab (RSGCRL)
              </Title>
              <Divider className="ncgsa-divider" />
              <Paragraph className="lab-overview-description">
                Most vulnerable countries facing Climate Change risks with very low technical, financial and professional capacity to adapt/mitigate/prevent its adverse impact are often the developing countries around the globe. Climate Change aggravates the social inequalities, and intensifies social factors leading to displacement, conflicts, instability, and changes in migration patterns. Low budget and lacking in technical support/human and professional capacity are few among the biggest hurdles for these countries. RSGCRL focuses on SPACE BORNE DATA with proper GIS ANALYSES which can provide low cost and easy to adopt alternatives to adapt/mitigate/prevent Climate Change to support decision making systems of the developing world.
              </Paragraph>
              <Link to="/rsgcrl" className="lab-overview-link">
                <Button type="primary" className="lab-overview-button">Learn More</Button>
              </Link>
            </Col>
            <Col xs={24} md={9}>
              <div className="lab-overview-image-wrap">
                <Image src={RsgcrlImage} alt="Remote Sensing and GIS Climatic Research Lab" className="lab-overview-image" preview={false} />
              </div>
            </Col>
          </Row>
        </div>
      </section>
    </main>
    <FooterQuote
      variant="labs"
      quote="He created the night and the day and the sun and the moon; all heavenly bodies are swimming in an orbit."
      attribution="Qur’an 21:33"
    />
    <FooterComponent />
  </>
);

export default ResearchLabsScreen;
